var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionTransportLightRail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H8v2h8V0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.414 4A3.414 3.414 0 0 0 4 7.414V20a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.414A3.414 3.414 0 0 0 16.586 4H13l1-2h-2l-1 2H7.414ZM10 7a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1Zm-4 3h12v6H6v-6Zm1 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm11-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
    clipRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 22H6l-1 2h2l1-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 24-1-2h2l1 2h-2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionTransportLightRail);
export default __webpack_public_path__ + "static/media/ic_action_transport_light_rail.90e89ae519fb4b34298a6d0b2b04ef35.svg";
export { ForwardRef as ReactComponent };